import {RouteComponentProps} from "react-router";
import {RouteMap} from "../types/router/route";
import {observable, action} from "mobx";

export class GlobalStore {
  // メニューの開閉状態
  collapsed = false;

  // ルーティング中の状況(react-router から渡されるもの)
  routing: RouteComponentProps<any>;

  // ルーティング一覧
  routeMap: RouteMap = {};

  // 500エラー状態
  @observable hasServerError = false;

  @action
  setServerError(hasError: boolean) {
    this.hasServerError = hasError;
  }

  static setRouting<ROUTE_PARAMS_STATIC>(props: RouteComponentProps<ROUTE_PARAMS_STATIC>) {
    const {location, history, match} = props;
    globalStore.routing = {location, history, match}
  }

  fetchingNotices = false;
  notices = [];
}

export const globalStore = new GlobalStore();

